import { useEffect, useState } from "react"

const isSSR = typeof window === "undefined"

function useMediaQuery(mediaQuery) {
  const [isVerified, setIsVerified] = useState(false)

  useEffect(() => {
    if (isSSR) return undefined

    const mediaQueryList = window.matchMedia(mediaQuery)
    const documentChangeHandler = () => setIsVerified(!!mediaQueryList.matches)

    mediaQueryList.addListener(documentChangeHandler)

    documentChangeHandler()

    return () => {
      mediaQueryList.removeListener(documentChangeHandler)
    }
  }, [mediaQuery])

  return isVerified
}

export default useMediaQuery
